<template>
    <div>
        <!-- dialog START -->
        <el-dialog v-dialog-drag :visible.sync="dialogVisible" class="eldialog eldialogC no_print eldialogWidth" :modal="false" :title="form_params.id==''?'新建云链采购单':'云链采购单'" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <el-form class="clearfix dialogForm dialogFormB" :model="form_params" ref="saleorderA">
                    <div class="elFormBox">
                        <el-form-item  label="供应商名称：" class="selectCustomerNoDown">
                            <el-input v-model="form_params.supplier" :disabled="!isEdit"></el-input>
                            <i class="el-input__icon el-icon-more" v-if="isEdit" @click="dialogVisibleCustomer=!dialogVisibleCustomer"></i>
                        </el-form-item>
                         <el-form-item label="采购日期：">
                            <el-date-picker v-model="contract_time" :disabled="!isEdit" type="date" placeholder="" size="mini"></el-date-picker>
                        </el-form-item>
                    </div>
                    <div class="elFormBox">
                        <el-form-item label="联系人：">
                            <el-input v-model="form_params.linkman" :disabled="!isEdit"></el-input>
                        </el-form-item>
                        <el-form-item label="联系电话：">
                            <el-input v-model="form_params.phone" :disabled="!isEdit"></el-input>
                        </el-form-item>
                    </div>
                    <div class="elFormBox elDialogElFormBoxCheckbox">
                        <el-form-item  label="REC：">
                            <el-checkbox v-model="form_params.rec"></el-checkbox>
                            <el-input v-model="form_params.tax_rate" v-if="form_params.rec" @input="calculationTableTotal(),recDigit($event)" placeholder="税率%：" class="checkbox elDialogElFormBoxCheckboxREC"></el-input>
                        </el-form-item>
                        <el-form-item  label="采购人：">
                            <el-select class="search_select search_inputBox" v-model="form_params.purchaser_id" filterable placeholder="采购人" @visible-change="getSelectList('user')">
                                <el-option v-for="list in selectMap.user" :key="list.id" :value="list.id" :label="list.name"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="elFormBox" style="margin-left:20px;">
                        <el-form-item>
                            <div class="getResource" v-if="isEdit" @click="dialogVisibleStock=!dialogVisibleStock">添加云链资源</div>
                        </el-form-item>
                        <el-form-item>
                            <div v-if="isEdit" class="setCost" @click="openbusinessRelation">关联采购费用</div>
                        </el-form-item>
                    </div>
                    <div class="globalFilterBtn" v-if="module.indexOf(',system-column-set,')!=-1" @click="filterDialogVisible=!filterDialogVisible"></div>
                </el-form>
                <div class="dialogFlow">
                    <div class="editBox">
                        <div class="editList">
                            <el-table :data="listDetail" ref="listDetailTable" border stripe highlight-current-row show-summary size="mini" height="100%">
                                <el-table-column type="index" label="序号" align="center" width="50"></el-table-column>
                                <el-table-column label="操作"  width="75" v-if="isEdit">
                                    <template slot-scope="scope">
                                        <div class="icon_wrap">
                                            <i class="operation_add" @click="listAdd" title="添加"></i>
                                            <i class="operation_delete" @click="listDetailDelete(scope.$index)" title="删除"></i>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="捆包号" width="110" show-overflow-tooltip v-if="billColumn.indexOf(',bale_no,')!=-1">
                                    <template slot-scope="scope">
                                        <el-input v-if="scope.row.isEdit&&isEdit" :disabled="!scope.row.isEdit" v-model="scope.row.bale_no"></el-input>
                                        <div v-else>{{scope.row.bale_no}}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="品名" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',breed,')!=-1">
                                    <template slot-scope="scope">
                                        <el-input v-if="scope.row.isEdit&&isEdit" :disabled="!scope.row.isEdit" v-model="scope.row.breed"></el-input>
                                        <div v-else>{{scope.row.breed}}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="品牌" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',brand,')!=-1">
                                    <template slot-scope="scope">
                                        <el-input v-if="scope.row.isEdit&&isEdit" :disabled="!scope.row.isEdit" v-model="scope.row.brand"></el-input>
                                        <div v-else>{{scope.row.brand}}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="等级" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',grade,')!=-1">
                                    <template slot-scope="scope">
                                        <el-input v-if="scope.row.isEdit&&isEdit" :disabled="!scope.row.isEdit" v-model="scope.row.grade"></el-input>
                                        <div v-else>{{scope.row.grade}}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="厚度" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',thickness,')!=-1">
                                    <template slot-scope="scope">
                                        <el-input v-if="scope.row.isEdit&&isEdit" :disabled="!scope.row.isEdit" v-model="scope.row.thickness"></el-input>
                                        <div v-else>{{scope.row.thickness}}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="长度" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',length,')!=-1">
                                    <template slot-scope="scope">
                                        <el-input v-if="scope.row.isEdit&&isEdit" :disabled="!scope.row.isEdit" v-model="scope.row.length"></el-input>
                                        <div v-else>{{scope.row.length}}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="片数" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',pieces,')!=-1">
                                    <template slot-scope="scope">
                                        <el-input v-if="scope.row.isEdit&&isEdit" :disabled="!scope.row.isEdit" v-model="scope.row.pieces"></el-input>
                                        <div v-else>{{scope.row.pieces}}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="层数" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',layer_number,')!=-1">
                                    <template slot-scope="scope">
                                        <el-input v-if="scope.row.isEdit&&isEdit" :disabled="!scope.row.isEdit" v-model="scope.row.layer_number"></el-input>
                                        <div v-else>{{scope.row.layer_number}}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="立方" width="80" prop="cube" show-overflow-tooltip v-if="billColumn.indexOf(',cube,')!=-1">
                                    <template slot-scope="scope">
                                        <el-input v-if="scope.row.isEdit&&isEdit" @input="calPrice(scope.$index,scope.row.cube,scope.row.cube_price)" :disabled="!scope.row.isEdit" v-model="scope.row.cube"></el-input>
                                        <div v-else>{{scope.row.cube}}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="采购单价" width="80" show-overflow-tooltip v-if="billColumn.indexOf(',cube_price,')!=-1">
                                    <template slot-scope="scope">
                                        <el-input v-if="scope.row.isEdit&&isEdit" @input="calPrice(scope.$index,scope.row.cube,scope.row.cube_price)" :disabled="!scope.row.isEdit" v-model="scope.row.cube_price"></el-input>
                                        <div v-else>{{scope.row.cube_price}}</div>
                                    </template>
                                </el-table-column>
                                <el-table-column label="采购金额" prop="total_amount" width="100" show-overflow-tooltip v-if="billColumn.indexOf(',total_amount,')!=-1">
                                    <template slot-scope="scope">
                                        {{ scope.row.total_amount}}
                                    </template>
                                </el-table-column>
                                <el-table-column label="备注" width="120" show-overflow-tooltip v-if="billColumn.indexOf(',remark,')!=-1">
                                    <template slot-scope="scope">
                                        <el-input v-if="scope.row.isEdit&&isEdit" :disabled="!scope.row.isEdit" v-model="scope.row.remark"></el-input>
                                        <div v-else>{{scope.row.remark}}</div>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                    <div class="dialogTotal clearfix">
                        <div class="dialogTotalC">合计应付</div>
                        <div class="dialogTotalC" v-if="tableTotal.sales_amount&&tableTotal.sales_amount!=0.00">采购金额:{{tableTotal.sales_amount}}</div>
                        <!-- <div class="dialogTotalC" v-if="tableTotal.discount_amount&&tableTotal.discount_amount!=0.00">折扣金额:{{tableTotal.discount_amount}}</div> -->
                        <template v-if="form_params.id">
                            <div class="dialogTotalC" v-for="(item,index) in form_params.payments" :key="index">{{item.name}}:{{item.amount}}</div>
                        </template>
                        <div class="dialogTotalC" v-if="tableTotal.tax_amount&&tableTotal.tax_amount!=0.00&&form_params.id==''">税金:{{tableTotal.tax_amount}}</div>
                        <!-- <div class="dialogTotalC" v-if="tableTotal.traffic_amount&&tableTotal.traffic_amount!=0.00">关联应收:{{tableTotal.traffic_amount}}</div> -->
                        <!-- <div class="dialogTotalC" v-if="tableTotal.other_amount&&tableTotal.other_amount!=0.00">其它费用:{{tableTotal.other_amount}}</div> -->
                        <!-- <div class="dialogTotalC" v-if="tableTotal.reduce_amount&&tableTotal.reduce_amount!=0.00">优惠:{{tableTotal.reduce_amount}}</div> -->
                        <div class="dialogTotalC" v-if="tableTotal.receivable_amount&&tableTotal.receivable_amount!=0.00&&form_params.id==''">应付金额:{{tableTotal.receivable_amount}}</div>
                        <div class="dialogTotalC" v-if="form_params.id">应付金额:{{form_params.pay_amount}}</div>
                    </div>
                    <div class="remarkBox">
                        <textarea class="remarkTextarea" v-model="form_params.remark" cols="5"></textarea>
                    </div>

                </div>
                <div class="editPersonBox clearfix">
                    <div class="editPerson">制单人：{{form_params.creator_name}}</div>
                    <div class="editPerson">审核人：{{form_params.auditor_name}}</div>
                    <!-- <div class="editPerson">打印时间：{{parseInt(new Date().getTime()/1000) | dateFormat_}}</div> -->
                </div>
                <div class="editBtnList clearfix">
                    <div style="float:left;">
                        <div v-if="newFee.length>0" class="clearfix" style="float:left;">
                            <div class="newFee" v-for="(list,index) in newFee" :key="'_'+index">
                                {{list.fee_name+':  ￥'+list.amount}}
                                <img src="../../assets/top-delete-suspension.png" v-if="form_params.id==''" class="newFeeImg" @click="delOutFee(index)"/>
                            </div>
                        </div>
                    </div>
                    <div class="editBtn">
                        <el-button class="funcPublicBtn" @click="save(0)">保存</el-button>
                        <el-button class="funcPublicBtn funcPublicBtnChecked" style="width:110px;" @click="save(1)">保存并提交审核</el-button>
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- dialog END -->
        <!--选择客户START-->
        <el-dialog v-dialog-drag  :visible.sync="dialogVisibleCustomer" class="eldialog eldialogStock" width="825px" :modal="false" title="选择供应商" custom-class="full_dialog">
            <select-supplier @cancel="dialogVisibleCustomer=!dialogVisibleCustomer" @selectAndOut="selectAndOutCustomer"></select-supplier>
        </el-dialog>
        <!--选择客户END-->
        <!-- 字段过滤 START -->
        <filter-fields :tableData="filter" scene="cloud.purchase.view" :isGlobal="true" :filterDialogVisible="filterDialogVisible" @confirm="filterConfirm" @dialogChangeFunc="val=>{this.filterDialogVisible = val;}"></filter-fields>
        <!-- 字段过滤 END -->
        <el-dialog v-dialog-drag  :visible.sync="dialogVisibleStock" class="eldialog eldialogStock" width="1250px" :modal="false" title="云链选择" custom-class="full_dialog">
            <cloud-select-product ref="selectcloud" :dialog="dialogVisibleStock" :supplierName="supplierName" @cancel="cancel()" @selectData="selectData" @selectAndOut="selectAndOut"></cloud-select-product>
        </el-dialog>
        <!--添加费用START-->
        <el-dialog v-dialog-drag :visible.sync="businessRelation" class="eldialog eldialogLine" :modal="false" title="添加成本费用" custom-class="full_dialog">
            <div class="dialogSearchBox">
                <el-form ref="feeOutForm" :model="businessRelationForm" :rules="feeOutFormRlues" class="clearfix dialogFormB">
                    <el-form-item  label="日期：" prop="fee_date">
                        <el-date-picker v-model="businessRelationForm.fee_date" type="date" placeholder="" size="mini"></el-date-picker>
                    </el-form-item>
                    <el-form-item  label="费用名称：" prop="fee_id">
                        <el-select v-model="businessRelationForm.fee_id" @input="outFeeChange" @visible-change="getSelectList('purchaseCost')" clearable>
                            <el-option v-for="list in selectMap.purchaseCost" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select>
                        <!-- <el-select v-model="businessRelationForm.fee_id" @input="outFeeChange" @visible-change="outFeeSelectFunc" clearable>
                            <el-option v-for="list in outFeeSelect" :key="list.id" :value="list.id" :label="list.name"></el-option>
                        </el-select> -->
                    </el-form-item>
                    <el-form-item  label="收款人(单位)：" prop="payee">
                        <el-input v-model="businessRelationForm.payee"></el-input>
                    </el-form-item>
                    <el-form-item  label="金额(￥)：" prop="amount">
                        <el-input v-model="businessRelationForm.amount"></el-input>
                    </el-form-item>
                    <el-form-item  label="提供发票：" prop="is_invoice">
                        <el-select v-model="businessRelationForm.is_invoice">
                            <el-option value="1" label="是"></el-option>
                            <el-option value="0" label="否"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item  label="备注：" prop="remark">
                        <el-input v-model="businessRelationForm.remark"></el-input>
                    </el-form-item>
                    <div class="elFormBoxBtnListCol">
                        <el-button class="funcPublicBtn" @click="businessRelation=!businessRelation" style="margin-right:15px!important;">取消</el-button>
                        <el-button class="funcPublicBtn funcPublicBtnChecked" v-if="form_params.id" @click="saveOutFee">确认</el-button>
                        <el-button class="funcPublicBtn funcPublicBtnChecked" v-else @click="newOutFee">确认</el-button>
                    </div>
                </el-form>
            </div>
        </el-dialog>
        <!--添加费用END-->
    </div>
</template>
<script>
import selectSupplier from '../selectSupplier.vue';
export default {
    props:["dialogCloud","id","cloudIsEdit"],
    data(){
        return{
            module:localStorage.dw_erp_power_code,
            categoryRawType:localStorage.dw_erp_category.indexOf("raw")!=-1?true:false,
            categoryBoardType:localStorage.dw_erp_category.indexOf("board")!=-1?true:false,
            dialogVisibleCustomer:false,
            dialogVisible:false,
            contract_time:new Date(),
            filterDialogVisible:false,
            filter:[],
            dialogVisibleStock:false,
            businessRelation:false,
            feeOutFormRlues:{
                fee_date:[ { required: true, message: '请填写日期', trigger: 'blur' }],
                fee_id:[ { required: true, message: '请选择费用名称', trigger: 'blur' }],
                payee:[ { required: true, message: '请填写收款人', trigger: 'blur' }],
                amount:[ { required: true, message: '请填写金额', trigger: 'blur' }],
                is_invoice:[ { required: true, message: '请选择是否开票', trigger: 'blur' }],
            },
            listDetail:[{isEdit:true,inventory_cloud_id:"",inventory_company_id:"",bale_no:"",breed:"",brand:"",grade:"",thickness:"",length:"",width_total:"",width:[],cube:"",cube_price:"",total_amount:"",pieces:"",layer_number:"",remark:""}],
            form_params:{
                id:"",
                supplier:"",
                contract_time:"",
                linkman:"",
                phone:"",
                remark:"",
                is_request_review:0,
                tax_rate:"",
                rec:0,
                purchaser_id:"",
                details:[],
                fee_list:[]
            },
            billColumn:"",
            tableTotal:{
                sales_amount:0.00,
                discount_amount:0.00,
                tax_amount:0.00,
                traffic_amount:0.00,
                other_amount:0.00,
                reduce_amount:0.00,
                receivable_amount:0.00,
            },
            isEdit:false,
            newFee:[],
            businessRelationForm:{
                purchase_id:"",
                fee_date:"",
                fee_id:"",
                fee_name:"",
                payee:"",
                amount:"",
                is_invoice:"",
                contract_no:"",
                remark:""
            },
            outFeeSelect:[],
            selectMap:{
                purchaseCost:[],
                user:[]
            },
            supplierName:""
        }
    },
    created(){
        this.getBillColumn();
        this.getSelectList("user")
    },
    components:{
        selectSupplier
    },
    methods:{
        saveOutFee(){
            this.businessRelationForm.purchase_id = this.form_params.id;
            this.businessRelationForm.contract_no = this.form_params.contract_no;
            this.businessRelationForm.payee = this.form_params.supplier;
            for(let key in this.businessRelationForm){
                if(this.businessRelationForm[key]===""){
                    if(key!="remark"){
                        this.tip("请填写完整信息","warning")
                        return;
                    }
                }
            }
            let time = this.businessRelationForm.fee_date;
            this.businessRelationForm.fee_date=this.formatTimeZero(this.businessRelationForm.fee_date);
            this.postFuncLoading("/erp/purchase.cost.create",this.businessRelationForm,()=>{
                this.businessRelation=!this.businessRelation;
                this.tip("添加成功","success")
                this.newFee.push(JSON.parse(JSON.stringify(this.businessRelationForm)))
                //this.getFeeList()
                // this.rowClick({id:this.form_params.id})
            },error=>{
                this.businessRelationForm.fee_date = time;
                this.tip(error.data.message,"warning")
            })
        },
        outFeeChange(e){
            this.selectMap.purchaseCost.forEach(item=>{
                if(item.id==e){
                    this.businessRelationForm.fee_name = item.name;
                }
            })
        },
        //获取费用名称
        // outFeeSelectFunc(){
        //     this.postFunc("/erp/purchase.cost.type",{type:2},res=>{
        //         this.outFeeSelect=res.data.data;
        //     },error=>{
        //         this.tip(error.data.message,"warning")
        //     })
        // },
        getSelectList(target){
            let obj = new Object();
            if(target=="purchaseCost"){
                obj.types = 2;
            }
            this.$getSelectList(target,obj).then(res=>{
                this.selectMap[res.target]=res.list;
            })
        },
        newOutFee(){
            for(let key in this.businessRelationForm){
                if(this.businessRelationForm[key]==""){
                    if(key=="purchase_id"||key=="remark"||key=="contract_no"){
                        this.pl(key)
                    }else{
                        this.tip("请填写完整信息","warning")
                        return;
                    }
                }
            }
            // let time = this.businessRelationForm.fee_date;
            this.businessRelationForm.fee_date=this.formatTimeZero(this.businessRelationForm.fee_date);
            this.newFee.push(JSON.parse(JSON.stringify(this.businessRelationForm)))
            this.businessRelation=!this.businessRelation;
        },
        openbusinessRelation(){
            this.businessRelationForm.purchase_id = this.form_params.id;
            this.businessRelationForm.contract_no = this.form_params.contract_no;
            this.businessRelationForm.payee = this.form_params.supplier;
            this.businessRelation = !this.businessRelation
            this.businessRelationForm.fee_date = new Date();
        },
        delOutFee(ind){
            this.newFee.forEach((item,index)=>{
                if(index==ind){
                    this.newFee.splice(index,1)
                }
            })
        },
        recDigit(e){
            let digitOther = e.length - (e.lastIndexOf(".")+1) - 4
            if(digitOther > 0){
                this.form_params.tax_rate = e.substring(0,e.length - digitOther)
            }
        },
        //计算合计
        calculationTableTotal(){
            let sales_amount = 0;
            let discount_amount = 0;
            let tax_amount = 0;
            let traffic_amount = 0;
            let other_amount = 0;
            let reduce_amount = 0;
            // let receivable_amount = 0.00;
            if(this.listDetail.length>0){
                this.listDetail.forEach(item=>{
                    if(item.cube&&item.cube_price){
                        // sales_amount += this.keepPrice(Number(item.sales_cube)*Number(item.sales_price))
                        // sales_amount += Number(item.sales_cube)*Number(item.sales_price)
                        this.calcu(item.cube,item.cube_price,"mul",res=>{
                            // this.pl(res)
                            item.total_amount = res;
                            this.calcu(sales_amount,res,"add",val=>{
                                sales_amount = val
                            },2)
                        },2)
                    }
                })
            }
            if(this.form_params.rec==1){
                if(this.form_params.tax_rate!=""){
                    this.calcu(sales_amount,discount_amount,"reduce",res=>{
                        this.calcu(this.form_params.tax_rate,100,"div",ret=>{
                            this.calcu(res,ret,"mul",val=>{
                                tax_amount = val
                            },2)
                        },4)
                    },2)
                }else{
                    discount_amount = 0;
                }
                // tax_amount = this.keepPrice((sales_amount - discount_amount)*(Number(this.form_params.tax_rate)/100))
            }else{
                tax_amount = 0
            }
            this.tableTotal.sales_amount = sales_amount;
            this.tableTotal.tax_amount = tax_amount;
            this.calcu(sales_amount,tax_amount,"add",a=>{
                this.tableTotal.receivable_amount = a;
            },2)
        },
        getDetail(){
            this.postFuncLoading("/erp/cloud.purchase.view",{id:this.form_params.id},res=>{
                this.form_params = res.data.data.list;
                this.form_params.contract_time = res.data.data.list.contract_time * 1000;
                this.listDetail = res.data.data.list.details;
                this.newFee = res.data.data.list.fee_list;
                this.form_params.rec=this.form_params.rec==1?true:false;
                if(this.isEdit){
                    this.listDetail.forEach(item=>{
                        if(this.form_params.purchase_type == 2){
                            item.isEdit = true;
                        }
                    })
                }
                delete this.form_params.details;
                this.calculationTableTotal()
            },error=>{
                this.tip(error.data.message,"warning")
            })
        },
        calPrice(index,cube,price){
            let reg = new RegExp("^(\\+)?\\d+(\\.\\d+)?$");
            if(cube!=""){
                if(!reg.test(cube)){
                    this.tip("立方为正数","warning")
                    return;
                }
            }
            if(price!=""){
                if(!reg.test(price)){
                    this.tip("采购单价为正数","warning")
                    return;
                }
            }
            this.listDetail.forEach((item,ind)=>{
                if(index == ind){
                    this.calcu(cube,price,"mul",res=>{
                        this.listDetail[ind].total_amount = res;
                    },2)
                }
            })
            this.calculationTableTotal()
        },
        //选择库存信息
        selectData(row){
            let rowData = JSON.parse(JSON.stringify(row))
            rowData.forEach(item=>{
                item.thickness = item.sales_thickness;
                item.length = item.sales_length;
                item.cube = item.sales_cube;
                item.cube_price = item.sales_price;
            })
            this.listDetailSet(rowData)
        },
        selectAndOut(row){
            let rowData = JSON.parse(JSON.stringify(row))
            rowData.forEach(item=>{
                item.thickness = item.sales_thickness;
                item.length = item.sales_length;
                item.cube = item.sales_cube;
                item.cube_price = item.sales_price;
            })
            this.listDetailSet(rowData)
            this.dialogVisibleStock = !this.dialogVisibleStock;
        },
        listDetailSet(row){
            if(row.length<1){
                return;
            }
            let rows=JSON.parse(JSON.stringify(row));
            rows.forEach(item=>{
                item.inventory_id=item.id;
                item.id="";
                if(item.inventory_cloud_id){
                    item.supplier = item.company_name;
                }
                this.calcu(item.sales_cube,item.sales_price,"mul",res=>{
                    item.total_amount = res;
                })
                // item.totalPrice=parseFloat(Number(item.sales_cube)*Number(item.sales_price)).toFixed(2)
            })
            if(this.listDetail.length==1){
                if(this.listDetail[0].id==""&&this.listDetail[0].inventory_id==""){
                    this.listDetail=rows;
                    return;
                }
            }
            this.listDetail=this.listDetail.concat(rows)
            let result = [];
            let obj = {};
            let data=JSON.parse(JSON.stringify(this.listDetail))
            for(var i =0; i<data.length; i++){
                if(!obj[data[i].inventory_id]){
                    result.push(data[i]);
                    obj[data[i].inventory_id] = true;
                }
            }
            this.listDetail=result;
            this.calculationTableTotal()
        },
        cancel(){
            this.dialogVisibleStock = false;
        },
        listDetailDelete(index){
            this.listDetail.splice(index,1)
            if(this.listDetail.length < 1){
                this.listAdd()
            }
            this.calculationTableTotal()
        },
        listAdd(){
            this.listDetail.push({isEdit:true,inventory_cloud_id:"",inventory_company_id:"",bale_no:"",breed:"",brand:"",grade:"",thickness:"",length:"",width_total:"",width:[],cube:"",cube_price:"",total_amount:"",pieces:"",layer_number:"",remark:""})
        },
        selectAndOutCustomer(row){
            this.form_params.supplier=row[0].name;
            this.form_params.linkman=row[0].linkman;
            this.form_params.phone=row[0].phone;
            this.dialogVisibleCustomer = !this.dialogVisibleCustomer;
        },
        getBillColumn(scene){
            this.postFunc("/erp/company.column.data",{scene:"cloud.purchase.view"},response=>{
                this.billColumn = ","+response.data.data.fields.join(",").toString()+",";
                this.filter = response.data.data.columns;
            },error=>{
                this.tip(error.data.message,"warning")
            })
        },
        filterConfirm(){
            this.getBillColumn();
        },
        save(type){
            let url = "";
            if(this.form_params.id){
                url = "/erp/cloud.purchase.update";
            }else{
                url = "/erp/cloud.purchase.create";
            }
            this.form_params.is_request_review = type;
            this.form_params.contract_time = this.formatTimeZero(this.contract_time);
            this.form_params.fee_list = this.newFee;
            this.form_params.details = JSON.parse(JSON.stringify(this.listDetail))
            this.postFuncLoading(url,this.form_params,()=>{
                this.tip("添加成功","success")
                this.dialogVisible = false;
                this.$emit("success")
            },error=>{
                this.tip(error.data.message,"warning")
            })
        }
    },
    watch:{
        id:function(val){
            this.form_params.id = val;
            if(val!=""){
                this.getDetail()
            }
        },
        cloudIsEdit:function(val){
            this.isEdit = val;
        },
        dialogCloud:function(val){
            this.dialogVisible = val;
        },
        dialogVisible:function(val){
            if(!val){
                this.listDetail = [{isEdit:true,inventory_cloud_id:"",inventory_company_id:"",bale_no:"",breed:"",brand:"",grade:"",thickness:"",length:"",width_total:"",width:[],cube:"",cube_price:"",total_amount:"",pieces:"",layer_number:"",remark:""}]
                this.form_params = {id:"",supplier:"",contract_time:"",linkman:"",phone:"",remark:"",is_request_review:0,tax_rate:"",rec:0,details:[],fee_list:[]}
                this.newFee = [];
                this.tableTotal = {sales_amount:0.00,discount_amount:0.00,tax_amount:0.00,traffic_amount:0.00,other_amount:0.00,reduce_amount:0.00,receivable_amount:0.00}
                this.$emit("close")
            }else{
                this.form_params.purchaser_id = localStorage.dw_erp_user_id;
            }
        },
        dialogVisibleStock:function(val){
            if(!val){
                if(this.$refs['selectcloud']){
                    this.$refs['selectcloud'].resetSelect();
                }
            }
        },
        "form_params.supplier":function(val){
            this.supplierName = val;
        }
    }
}
</script>
<style scoped lang="scss">
    .dialogFormB{padding:10px 0;}
    .getResource{font-size: 12px;color:#333;border:1px solid #333;border-radius: 3px;padding:3px 10px;display: inline-block;line-height: 20px;cursor: pointer;margin-left:10px;}
    .getResource:hover{color:#b21111;border-color:#b21111;}
    .setCost{font-size: 12px;color:#333;border:1px solid #333;border-radius: 3px;padding:3px 10px;display: inline-block;line-height: 20px;cursor: pointer;margin-left:10px;position: relative;}
    .setCost:hover{color:#b21111;border-color:#b21111;}
    .el-icon-more{position: absolute;right:0;cursor: pointer;top:2px;}
    .bottom_flex{ display: flex; padding-right: 12px; padding-bottom: 8px; }
    .editPayBox{
        .editPay{width:50%;float: left;height:100px;box-sizing:border-box;padding:10px;}
        .editName{font-size: 12px;color:#777;}
        .editPay:nth-child(2n){border-left:1px solid #ccc;}
    }
    .editPersonBox{
        .editPerson{width:33%;float: left;font-size: 12px;color:#777;box-sizing: border-box;padding:5px 0;}
    }
    .editBtnList{padding-top:10px;
        .editTax{float: left;}
        .editTaxname{float: left;font-size: 12px;color:#777;line-height: 25px;margin-right:5px;}
        .editTaxinput{float: left;width:100px;}
        .editBtn{float: right;}
    }
    .remarkBoxFourText{padding:5px 5px 5px 60px;}
    .remarkBoxFourText:before{content:"退货原因:";}
</style>